/** Feature flags. Flip to true, to re-enable. */
export const SCHOOLHUB_ENABLED = false;
